import React, { useState } from 'react'
import { AppBar, Box, makeStyles } from '@material-ui/core'
import { MAP_ID } from '../../utils/apiHelper'
import { t } from '../../utils/languages'
import { useMapEngine } from '../shared'
import { Select } from '@facility-latam/geoportal-components'

import {
  useGlobalContext,
  countryChanged,
  projectChanged,
  priorityChanged,
  setFeatures,
  sideBarRightVisibilityChanged
} from '../../state'

const countries = [
  {
    value: 'pdi',
    label: t('Sub-región PDI'),
    center: [-84, 16],
    zoom: 5
  },
  {
    value: 'mex',
    label: t('México'),
    center: [-90, 17],
    zoom: 6
  },
  {
    value: 'hnd',
    label: t('Honduras'),
    center: [-83, 15],
    zoom: 6.2
  },
  {
    value: 'slv',
    label: t('El Salvador'),
    center: [-87.5, 14],
    zoom: 7.5
  },
  {
    value: 'gtm',
    label: t('Guatemala'),
    center: [-88, 15],
    zoom: 6.5
  }
]

const projects = [
  {
    value: 'true',
    label: t('Proyectos PDI - Gobiernos (actualización Enero 2022)')
  },
  {
    value: 'false',
    label: t('Proyectos Sistema UN')
  },
  {
    value: 'trifinio',
    label: t('Plan Trifinio')
  },
  {
    value: 'cooperation',
    label: t('Agencias de cooperación')
  },
  {
    value: 'null',
    label: t('Todos los proyectos')
  }
]

const priorities = [
  {
    value: '1',
    label: t('Proyectos de implementación acelerada')
  },
  {
    value: '2',
    label: t('Proyectos prioritarios nacionales')
  },
  {
    value: '!1',
    label: t('Otros proyectos')
  },
  {
    value: 'null',
    label: t('Todos los proyectos')
  }
]

const useStyles = makeStyles((theme) => theme.header)

export const Header = () => {
  const { dispatch } = useGlobalContext()
  const [engine] = useMapEngine(MAP_ID)
  const classes = useStyles()
  const [country, setCountry] = useState(countries[0])
  const [project, setProject] = useState(projects[0])
  const [priority, setPriority] = useState(priorities[2])

  const handleCountryChange = (option) => {
    const { value, center, zoom } = option
    setCountry(option)
    engine.flyTo({ center, zoom })
    const country = option.value
    dispatch(countryChanged({ country }))
    dispatch(setFeatures({ features: [] }))
    dispatch(
      sideBarRightVisibilityChanged({
        selectedType: 'dataTable'
      })
    )
  }

  const handleProjectChange = (option) => {
    setProject(option)
    const projectType = option.value
    dispatch(projectChanged({ projectType }))
    dispatch(setFeatures({ features: [] }))
    dispatch(
      sideBarRightVisibilityChanged({
        selectedType: 'dataTable'
      })
    )
    engine.setLayoutProperty(
      'pdi_trifinio',
      'visibility',
      // TODO: change to valid layer
      option.value === 'trifinio' ? 'visible' : 'none'
    )
    option.value === 'trifinio' && engine.flyTo({ center: [-88.5, 14.5], zoom: 8, pitch: 0, bearing: 0 })
  }

  const handlePriorityChange = (option) => {
    setPriority(option)
    const priorityValue = option.value
    dispatch(priorityChanged({ priority: priorityValue }))
    dispatch(setFeatures({ features: [] }))
    dispatch(
      sideBarRightVisibilityChanged({
        selectedType: 'dataTable'
      })
    )
  }

  return (
    <AppBar className={classes.container}>
      <Box
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Select
          title={`${t('Pais')}/Sub-${t('región')}`}
          options={countries}
          label={country.label}
          onChange={handleCountryChange}
        />
        <Select
          title={t('Grupo de proyectos')}
          options={projects}
          label={project.label}
          onChange={handleProjectChange}
        />
        <Select
          title={t('Priorizado')}
          options={priorities}
          label={priority.label}
          onChange={handlePriorityChange}
        />
      </Box>
    </AppBar>
  )
}
